import React from 'react'
import styled from 'styled-components'

const Login = () => {
  return (
      <Container>
        <Content>
					<CTA>
						<CTAlogoOne src="/images/cta-logo-one.svg" alt="logo-one"/>
						<SignUp>GET ALL THERE</SignUp>
						<Description>Get Premier Access to Raya and the Last Dragon for an additional fee with a Disney+ subcription. As of 03/26/21, the price of Disney+ and The Deisney Bundle will increase by $1.</Description>
						<CTAlogoTwo src ="/images/cta-logo-two.png" alt="logo-two"/>
					</CTA>
					<BgImage/>
				</Content>
      </Container>
  )
}

const Container = styled.section`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  text-align: center;
  height: 100vh;
`;

const Content = styled.div`
  margin-bottom: 10vw;
  width: 100%;
  position: relative;
  min-height: 100vh;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
	padding: 80px 40px;
	height: 100%;
`;

const BgImage = styled.div`
  background-image: url("/images/login-background.jpg");
	background-position: top;
	background-size: cover;
	background-repeat: no-repeat;
	height: 100%;
	position: absolute;
	top: 0;
	right: 0;
	left: 0;
	z-index: -1;
`;

const CTA = styled.div`
	max-width: 650px;
	width: 100%;
	display: flex;
	flex-direction: column;
`;

const CTAlogoOne = styled.img`
  margin-bottom: 12px;
	max-width: 600px;
	min-height: 1px;
	display: block;
	width: 100%;
`;

const SignUp = styled.a`
  margin-bottom: 12px;
  font-weight: bold;
	color: #f9f9f9;
	background-color: #0A79DF;
	letter-spacing: 1.5px;
	font-size: 18px;
	width: 100%;
	padding: 16.5px 0;
	border: 1px solid transparent;
	border-radius: 4px;
	cursor: pointer;

	&:hover{
		background-color: #3498DB;
	}
`;

const Description = styled.p`
  color: hsla(0, 0%, 95.3%, 1);
	font-size: 11px;
	margin: 0 0 24px;
	line-height: 1.5;
	letter-spacing: 1.5px;
`;

const CTAlogoTwo = styled.img`
  max-width: 600px;
	margin-bottom: 20px;
	display: inline-block;
	vertical-align: bottom;
	width: 100%;
`

export default Login